// 
import WebComponent from '../webComponents/WebComponent';
import * as CursorSpinner from 'fg-frontend/src/components/CursorSpinner';

class GoogleRecaptcha extends WebComponent {
  constructor(props) {
    super(props);
    this.isRecaptchaExecuted = false;
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleResponse = this.handleResponse.bind(this);
  }

  didMount() {
    const {
      grInput,
      grForm,
      grSubmit,
      grMode,
    } = this.props;

    this.inputElement = document.getElementById(grInput);

    if (grMode != 'checkbox') {
      if (grForm) {
        this.formElement = document.getElementById(grForm);
      } else {
        this.formElement = this.element.closest('form');
      }

      if (this.formElement) {
        if (grSubmit) {
          this.submitElement = document.getElementById(grSubmit);
        } else {
          this.submitElement = this.formElement.querySelector('[type="submit"]');
        }
        if (this.submitElement) {
          this.submitElement.addEventListener('click', this.handleSubmit);

          // google recaptcha response handler
          window.submitFormWithRecaptchaResponse = response => {
            this.handleResponse(response);
          };
        }
      }
    }
    else {
      window.writeSuccessfulRecaptchaResponseToInput = response => {
        this.handleResponseCheckbox(response);
      };
    }
  }

  handleSubmit(e) {
    const {
      grMode,
      grAction,
      grSitekey
    } = this.props;

    if (!this.isRecaptchaExecuted) {
      e.preventDefault();
      e.stopPropagation();
      CursorSpinner.pushToQueue('googleRecaptcha');
      if (grecaptcha) {
        if (grMode == 'decisionManager') {
          grecaptcha.ready(() => {
            let params = {};
            if (grAction) {
              params['action'] = grAction;
            }
            grecaptcha.execute(grSitekey, params).then(this.handleResponse);
          });
        }
        else {
          grecaptcha.execute();
        }
      }
    }
  }

  handleResponse(response) {
    this.isRecaptchaExecuted = true;
    this.inputElement.value = response;
    CursorSpinner.removeFromQueue('googleRecaptcha');
    this.submitElement.click();
  }
  handleResponseCheckbox(response) {
    this.inputElement.value = response;
  }
}

export default GoogleRecaptcha;



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/GoogleRecaptcha.js